export default __webpack_public_path__ + "static/media/login1.31586684.png";